import React from 'react';
import Seo from '@/components/Seo';
import Hero from '@/components/Hero';
import AboutUs from '@/components/about-us/AboutUs.tsx';
import { Origins } from '@/components/origins';
import { Products } from '@/components/products';
import { Quality } from '@/components/quality';
import { Faq } from '@/components/faq';
import ContactUs from '@/components/contact-us/ContactUs.tsx';
import { siteConfig, type SectionKey } from '@/config/site.config';
import { faqContent } from '@/content/faq';

/**
 * Registry of all available home-page sections.
 * Mapping SectionKey to the actual React component.
 */
const SECTION_COMPONENTS: Record<SectionKey, React.ComponentType> = {
    hero: Hero,
    about: AboutUs,
    origins: Origins,
    products: Products,
    quality: Quality,
    faq: Faq,
    contact: ContactUs,
};

const Home: React.FC = () => {
    return (
        <>
            <Seo path="/" faq={faqContent.items} />
            {siteConfig.sections.map((key) => {
                const Component = SECTION_COMPONENTS[key];
                return Component ? <Component key={key} /> : null;
            })}
        </>
    );
};

export default Home;
